export const MAX_FEE = 100;
export const MIN_FEE = 0;
export const FEE_MAX_DECIMAL_PLACES = 5;
